import { createSlice } from '@reduxjs/toolkit';
import { loadMapConfig } from 'client/store/mapConfigSlice/mapConfigSlice';
import { defaultGBMapView } from './defaultGBMapView';

export const mapViewSlice = createSlice({
    name: 'mapView',
    initialState: {
        result: {
            mapView: defaultGBMapView
        },
        loading: false,
        error: false
    },
    extraReducers: {
        [loadMapConfig.pending]: state => {
            return {
                ...state,
                loading: true,
                error: false
            };
        },
        [loadMapConfig.fulfilled]: (state, action) => {
            const { mapView } = action?.payload || {};
            return {
                ...state,
                result: {
                    ...state.result,
                    mapView: mapView || defaultGBMapView
                },
                loading: false,
                error: false
            };
        },
        [loadMapConfig.rejected]: state => {
            return {
                ...state,
                result: {
                    ...state.result,
                    mapView: defaultGBMapView
                },
                loading: false,
                error: true
            };
        }
    }
});

export default mapViewSlice.reducer;
